import SMSTooltip from './sms'
import WhatsappTooltip from './whatsapp-tooltip'
import WeightWidgetTooltip from './wight-widget-tooltip'

type Props = {
  defaultPhonNumber?: string
}

function LeftToolbar(props: Props) {
  const { defaultPhonNumber } = props

  return (
    <div className="fixed left-0 top-0 bottom-0 bg-white w-[56px]">
      <div className="mt-4 space-y-14 flex flex-col items-center">
        <WhatsappTooltip defaultPhonNumber={defaultPhonNumber} />
        <SMSTooltip defaultPhonNumber={defaultPhonNumber} />
        <WeightWidgetTooltip />
      </div>
    </div>
  )
}

export default LeftToolbar
